import store from 'store';

export default () => !!store.get('loggedIn');


// WEBPACK FOOTER //
// ./src/helpers/isLoggedIn.js